import React, { FC } from 'react'

import { Box, Container } from '@material-ui/core'
import { StyleRules, makeStyles, Theme } from '@material-ui/core/styles'

import ExtendedButton from '~/components/shared/ExtendedButton'
import Loader from '~/components/shared/Loader'
import Text, { Title } from '~/components/shared/Text'

import { useMobile } from '~/hooks/responsive'
import { createSubmit } from '~/utils/createSubmit'

import Flexbox from '../Flexbox'

import { WizardStepWrapperProps } from './types'

const useStyles = makeStyles(
  (theme: Theme): StyleRules => ({
    backBtn: {
      '&:not(:hover)': {
        borderColor: theme.palette.text.primary,
        color: theme.palette.text.primary
      }
    }
  })
)

const WizardStepWrapper: FC<WizardStepWrapperProps> = ({
  handleSubmit,
  onNext,
  onBack,
  onDraft,
  title,
  description,
  maxWidth = 'sm',
  loading,
  nextText,
  children,
  disabled,
  submitting,
  disabledBack,
  disabledNext,
  buttonPosition = 'space-between',
  saveText
}) => {
  const isMobile = useMobile()
  const classes = useStyles()

  if (loading) return <Loader my={8} />

  return (
    <Box my={4}>
      <Container maxWidth={maxWidth}>
        <Box
          component={handleSubmit ? 'form' : 'div'}
          onSubmit={handleSubmit && createSubmit({ handleSubmit })}
          display="flex"
          flexDirection="column"
        >
          {title && (
            <Title textAlign="center" variant="h1" my="0.66em" fontSize={30}>
              {title}
            </Title>
          )}

          {description && (
            <Text textAlign="center" mb={3}>
              {description}
            </Text>
          )}

          {children}

          <Box
            display={onBack ? 'flex' : 'block'}
            flexDirection="row"
            justifyContent={buttonPosition}
            mt={6}
          >
            {onBack && (
              <ExtendedButton
                minWidth={isMobile ? 20 : 155}
                className={classes.backBtn}
                variant="text"
                onClick={onBack}
                disabled={disabled || disabledBack}
                mr={isMobile ? 2 : 1}
                size="large"
                style={{ fontFamily: 'Prompt, sans-serif', fontSize: 16 }}
              >
                Back
              </ExtendedButton>
            )}
            <Flexbox flexDirection="row" justifyContent="space-between">
              {onDraft && (
                <ExtendedButton
                  onClick={onDraft}
                  size="large"
                  variant="outlined"
                  width={isMobile ? 125 : 150}
                  disabled={disabled || disabledNext}
                  style={{
                    fontFamily: 'Prompt, sans-serif',
                    fontSize: 16,
                    borderColor: '#808080',
                    marginRight: '20px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {saveText || 'Save Draft'}
                </ExtendedButton>
              )}
              {onNext && (
                <ExtendedButton
                  type={handleSubmit ? 'submit' : 'button'}
                  {...(handleSubmit ? {} : { onClick: onNext })}
                  size="large"
                  minWidth={isMobile ? 125 : 150}
                  disabled={disabled || disabledNext}
                  loading={submitting}
                  style={{
                    fontFamily: 'Prompt, sans-serif',
                    fontSize: 16,
                    color: '#fff'
                  }}
                >
                  {nextText || 'Continue'}
                </ExtendedButton>
              )}
            </Flexbox>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default WizardStepWrapper
